import { ContractDataWithLinks, FetchContractError, getContractsEndpoint } from 'cpes-common';
import { getSimpleDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from 'cp-xhr';

const { reducer, fetchData } = getSimpleDataFetchSlice<ContractDataWithLinks[], FetchContractError>({
    dataName: 'contracts',
    fetchCallback() {
        return CpDataApi.get(getContractsEndpoint()).then(response => response.data);
    },
});

export default reducer;
export const fetchContracts = fetchData;
